import { useAuth as useOidcAuth } from "react-oidc-context";
import { useEffect } from "react";

let refreshInFlight = null;
let lastRefreshStartedAt = 0;
const MIN_REFRESH_INTERVAL_MS = 60 * 1000;
const MIN_TIMEOUT_MS = 5000;

export function useTokenRefresher() {
  const auth = useOidcAuth();

  useEffect(() => {
    if (!auth.user?.expires_at) return;

    // Convert expiry (in seconds) to milliseconds
    const expiryTime = auth.user.expires_at * 1000;
    const now = Date.now();

    // Refresh 30 minutes before expiry
    const refreshBefore = expiryTime - 30 * 60 * 1000;
    const timeoutMs = Math.max(MIN_TIMEOUT_MS, refreshBefore - now);

    const timeout = setTimeout(() => {
      const sinceLast = Date.now() - lastRefreshStartedAt;
      if (refreshInFlight || sinceLast < MIN_REFRESH_INTERVAL_MS) {
        return;
      }

      lastRefreshStartedAt = Date.now();
      console.log("Refreshing token 30 min before expiry...");
      refreshInFlight = auth
        .signinSilent() // will use refresh_token if available
        .catch((error) => {
          console.error("Silent token refresh failed:", error);
        })
        .finally(() => {
          refreshInFlight = null;
        });
    }, timeoutMs);

    return () => clearTimeout(timeout);
  }, [auth.user, auth]);
}
